export default "__VITE_ASSET__BM_55247__";